// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { DealerAttachment } from './dealer-attachment';
import { DealerTerm } from './dealer-term';
import { PricingTier } from './pricing-tier';
import { SalesRep } from './sales-rep';
import { ShipAddress } from './ship-address';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Dealer extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static DealerOptions = {
        Miscellaneous: 285,
        TireSales: 363,
        GenesisStock: 364
    }

    get displayName() {
        if (!!this.companyName && !!this.contactName) return `${this.companyName} - ${this.contactName}`;
        if (!!this.companyName) return this.companyName;
        if (!!this.contactName) return this.contactName;
    }

    get inactiveBool() {
        return !!this.inactive;
    }
    get isSent() {
        return !!this.sent;
    }
    get isValidated() {
        return !!this.validated;
    }
    get isSubmitted() {
        return !!this.submitted;
    }
    get isReadyToExport() {
        return !!this.readyToExport;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  aPEmail?: string;
  accountNumber?: string;
  billAddress1?: string;
  billAddress2?: string;
  billCity?: string;
  billCountry?: string;
  billCountryOther?: string;
  billState?: string;
  billZip?: string;
  channelPartner!: boolean;
  code?: string;
  colorCode?: string;
  companyName?: string;
  contactName?: string;
  created?: Date;
  dealerTermId?: number;
  deleted?: Date;
  eIN?: string;
  email?: string;
  fax?: string;
  freight?: number;
  inactive?: Date;
  loadedMiles!: number;
  noPrePay!: boolean;
  northpointCIN?: string;
  northpointCINVerified?: Date;
  notes?: string;
  pastDue?: Date;
  phone1?: string;
  phone2?: string;
  portalEmail?: string;
  pricingTierId?: number;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  quickBooksOnlineId?: string;
  quickBooksOnlineLastExport?: Date;
  readyToExport?: Date;
  redOakCIN?: string;
  redOakCINVerified?: Date;
  rep?: string;
  resaleNumber?: string;
  salesNotes?: string;
  salesOrderPricingVisible!: boolean;
  salesRepId?: number;
  sent?: Date;
  shipSameAsBilling!: boolean;
  shippingNote?: string;
  submitted?: Date;
  terms?: string;
  validated?: Date;
  viewed?: Date;
  website?: string;
  dealerAttachments!: DealerAttachment[];
  dealerTerm!: DealerTerm;
  pricingTier!: PricingTier;
  salesRep!: SalesRep;
  shipAddresses!: ShipAddress[];
}

